import { useState, useCallback } from 'react';

/**
 * Napalm overlay for deploy effects that incinerate opponent zones only (e.g. Spinosaurus 397).
 */
export const useDeployOpponentNapalm = () => {
  const [activeNapalms, setActiveNapalms] = useState([]);

  const triggerNapalm = useCallback((key, zoneDamageTargets = []) => {
    if (!key) {
      throw new Error('useDeployOpponentNapalm: key is required');
    }
    if (!Array.isArray(zoneDamageTargets)) {
      throw new Error('useDeployOpponentNapalm: zoneDamageTargets must be an array');
    }
    setActiveNapalms((prev) => [...prev, { key, zoneDamageTargets }]);
  }, []);

  const completeNapalm = useCallback((key) => {
    setActiveNapalms((prev) => prev.filter((n) => n.key !== key));
  }, []);

  return { activeNapalms, triggerNapalm, completeNapalm };
};

export default useDeployOpponentNapalm;
